export const apiGetActivities = "/quytrinh/api/v1/GetActivities"
export const apiStartPractise = "/quytrinh/api/v1/StartPractise"
export const apiClosePractise = "/quytrinh/api/v1/ClosePractise"
export const apiGetErrorLog = "/quytrinh/api/v1/GetErrorLog"
